import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintReport } from '.';

/**
 * @component {kat-blueprint-report-action} KatBlueprintReportAction Component used to place and filter components within the action section.
 * @slot default Blueprint content for action section.
 */
@register(KatBlueprintReport.slotMapping.action.name)
export class KatBlueprintReportAction extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintReport.slotMapping.action.name,
      KatBlueprintReport.slotMapping.action.allowed
    );
  }
}
